import { helpers, ts } from '_core';

import { DraftParams } from './types';

export const formatSeriesName = (key: string, baskets: ts.types.basket.Basket[]) => {
  const currentBasket = baskets.find((b) => b.handle == key);
  if (currentBasket) return currentBasket.name;
  return key;
};

export const prepareLinearData = (
  localData: ts.types.widgets.TableData,
  basketId: number,
  basketIds: number[],
  baskets: ts.types.basket.Basket[] = []
) => {
  const newData = localData.map((el) => {
    const newRow = {
      date: el.date,
    } as ts.types.widgets.TableData[number];

    Object.keys(el).forEach((key) => {
      const formattedKey = formatSeriesName(key.split('-')[0], baskets);
      if (key.includes('-portfolio_count')) {
        newRow[formattedKey] = el[key];
      }
    });
    return newRow;
  });

  return newData;
};

export const validate = (params: DraftParams) => helpers.validations.validBasketCompare(params);
